import React, { Component, Fragment } from 'react';
import { AdminAuthentication } from "../../utils/authentication";
import ResponsiveAppBar from '../../components/components/appbar';
import ResponsiveFooter from '../../components/components/footer';



class Admin extends Component {
    constructor(props: any) {
        super(props);
        AdminAuthentication();

    }
    componentDidMount(): void { }
    componentWillUnmount(): void { }
    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <p>Admin screen</p>
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default Admin;